var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSortDisabled(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.2929 5.29289C11.6834 4.90237 12.3166 4.90237 12.7071 5.29289L15.7071 8.29289C15.9931 8.57889 16.0787 9.00901 15.9239 9.38268C15.7691 9.75636 15.4045 10 15 10H9C8.59554 10 8.2309 9.75636 8.07612 9.38268C7.92134 9.00901 8.00689 8.57889 8.29289 8.29289L11.2929 5.29289Z",
    fill: "#ACA7A7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.2929 18.7071C11.6834 19.0976 12.3166 19.0976 12.7071 18.7071L15.7071 15.7071C15.9931 15.4211 16.0787 14.991 15.9239 14.6173C15.7691 14.2436 15.4045 14 15 14H9C8.59554 14 8.2309 14.2436 8.07612 14.6173C7.92134 14.991 8.00689 15.4211 8.29289 15.7071L11.2929 18.7071Z",
    fill: "#ACA7A7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortDisabled);
export default __webpack_public_path__ + "static/media/sort-disabled.19ca8bf510bb3b3349c19c3ed6c3ebc0.svg";
export { ForwardRef as ReactComponent };